"use client";

import { useEffect, useRef, useState } from "react";
import { Activity } from 'lucide-react';
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
function useCountUp(target: number, duration = 1400, start = false, decimals = 0) {
  const [value, setValue] = useState(0);
  const startedRef = useRef(false);
  useEffect(() => {
    if (!start || startedRef.current) return;
    startedRef.current = true;
    const startTime = performance.now();
    let raf = 0;
    const tick = (now: number) => {
      const elapsed = now - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 4);
      const current = target * eased;
      setValue(current);
      if (progress < 1) {
        raf = requestAnimationFrame(tick);
      } else {
        setValue(target);
      }
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [target, duration, start]);
  return decimals === 0 ? Math.round(value) : Number(value.toFixed(decimals));
}
import { Youtube, Eye, ChartBar as BarChart3, Rocket } from 'lucide-react';
const stats = [{
  icon: Youtube,
  value: 40,
  suffix: "K+",
  label: "YouTube Subscribers",
  color: "bg-red-500/10 text-red-500"
}, {
  icon: Eye,
  value: 8.5,
  suffix: "M+",
  label: "YouTube Views",
  color: "bg-blue-500/10 text-blue-500"
}, {
  icon: BarChart3,
  value: 200,
  suffix: "+",
  label: "Content Pieces Created",
  color: "bg-purple-500/10 text-purple-500"
}, {
  icon: Rocket,
  value: 7,
  suffix: "+",
  label: "Months Of Impact",
  color: "bg-indigo-500/10 text-indigo-500"
}];
function StatItem({
  stat,
  active,
  index
}: {
  stat: typeof stats[0];
  active: boolean;
  index: number;
}) {
  const count = useCountUp(stat.value, 1400, active, stat.value % 1 !== 0 ? 1 : 0);
  return <div data-index={index} className="flex flex-col items-center text-center p-6 transition-all duration-300 hover:bg-white/5 rounded-lg">
      <div className={`mb-6 flex h-12 w-12 items-center justify-center rounded-lg ${stat.color}`}>
        <stat.icon className="h-6 w-6" />
      </div>
      <div className="mb-2 text-3xl md:text-4xl font-bold text-white tracking-tight">
        {count}
        {stat.suffix}
      </div>
      <div className="text-sm font-medium text-muted-foreground uppercase tracking-wider font-mono">
        {stat.label}
      </div>
    </div>;
}
export default function Footprint() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    once: true,
    threshold: 0.15
  });
  return;
}